import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSparks } from '../../contexts/SparksContext';
import { shopAlert } from './shopNudge';
import { useShop } from './useCosmeticCatalogue';

/**
 * The nav's shop alert ({ canBuy, announce }, see shopNudge.js), never on the shop page itself. While a finish
 * sequence holds shop news it keeps what it showed before, so the sticker and bubble change only once it ends.
 */
export default function useShopAlert(childId) {
  const { balance, enabled, shopNewsHeld } = useSparks();
  const shop = useShop(enabled ? childId : null);
  const onShopPage = useLocation().pathname === '/shop';
  const live = shopAlert({ childId, shop, balance, onShopPage });
  const shown = useRef(live);
  if (!shopNewsHeld) shown.current = live;
  return { ...shown.current, balance };
}
